import { render, staticRenderFns } from "./sztd.vue?vue&type=template&id=ddee1df8&scoped=true&"
import script from "./sztd.vue?vue&type=script&lang=js&"
export * from "./sztd.vue?vue&type=script&lang=js&"
import style0 from "./sztd.vue?vue&type=style&index=0&id=ddee1df8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddee1df8",
  null
  
)

export default component.exports